import { format } from 'date-fns';

import { cn } from '@simplywallst/ui-core/next';

import { CompanyLogo } from '@/components/CompanyLogo';

import type { PortfolioUpdate } from './useUpdates';

export const Item = ({
  company,
  title,
  isRecent,
  time,
  description,
}: PortfolioUpdate) => {
  const { name, tickerSymbol, info } = company;
  return (
    <div className="grid cursor-pointer grid-cols-[40px_auto] items-start gap-x2 rounded-md p-x1 @[1024px]:hover:bg-surface-2 md:gap-x1_5">
      <div className="pt-x0_5">
        <CompanyLogo
          website={info?.url}
          tickerSymbol={tickerSymbol}
          size={40}
          hasLogo={info?.hasLogo}
          className="border-strong"
        />
      </div>
      <div className="grid items-center">
        <h4 className="m-0 mb-x0_5 text-xs font-normal text-soft">
          <span
            className={cn('block md:inline', isRecent ? 'mr-x1' : 'mr-x1_5')}
          >
            {name}
          </span>
          <span className="block whitespace-nowrap text-tiny text-softer md:inline">
            {isRecent && (
              <svg
                width="6"
                height="6"
                viewBox="0 0 6 6"
                className="-mt-x0_5 mr-x0_75 align-middle"
              >
                <circle cx="3" cy="3" r="3" className="fill-attention" />
              </svg>
            )}
            <span>{format(time, 'MMM d, yyyy')}</span>
          </span>
        </h4>
        <p className="mb-x0_5 line-clamp-2 text-xs leading-normal text-solid">
          {title}
        </p>
        <p className="mb-x0_5 line-clamp-2 text-xs leading-normal text-soft">
          {description}
        </p>
      </div>
    </div>
  );
};
